import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'The Raycast Keyboard',
    description: "A low-profile mechanical keyboard designed for instant access to your favorite commands. Designed by Raycast and engineered by NuPhy.",
    placeholder: 'A low-profile mechanical keyboard designed for instant access to your favorite commands.',
    url: getOrigin()
}
